import React from 'react';
import { connect } from 'react-redux';
import { toggleSidebar } from '../../actions';

class MainHeader extends React.Component {

	constructor(props) {
		super(props);
		this.minilogo = window.envBooqadmin.minilogo ? <span dangerouslySetInnerHTML={{__html: window.envBooqadmin.minilogo}}/> : <span><b>bq</b>a</span>;
		this.largelogo = window.envBooqadmin.largelogo ? <span dangerouslySetInnerHTML={{__html: window.envBooqadmin.largelogo}}/> : <span><b>booq</b>admin</span>;
	}

    toggleSidebar = (e) => {
		e && e.preventDefault();
		this.props.toggleSidebar();
	}

	render() {
		return (
			<header className="main-header">
				<a href="#" className="logo" onClick={(e) => {e.preventDefault()}}>
					<span className="logo-mini">{ this.minilogo }</span>
					<span className="logo-lg">{ this.largelogo }</span>
				</a>
				<nav className="navbar navbar-static-top">
					<a href="#" className="sidebar-toggle" data-toggle="push-menu" role="button" onClick={ this.toggleSidebar }>
						<span className="sr-only">Toggle navigation</span>
					</a>
					<div className="navbar-custom-menu">
						<ul className="nav navbar-nav">
							{ this.props.children }
						</ul>
					</div>
				</nav>
			</header>
		);
	}
}

export default connect((state) =>{
	return {
		config: state.app.template,
		user: state.app.user
	};
},{toggleSidebar})(MainHeader);